import type React from "react";
import {Tag} from "~/components/tag/Tag";
import {termDays} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Format.ts";
import {BASELINE_DAYS} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Calc.ts";

/** A SAP term code, coloured against the baseline: at/above in green, 30+ in blue, shorter in amber. */
export const PtV2TermTag: React.FC<{code: string}> = ({code}) => {
    const d = termDays(code);
    const color = d == null ? 'default' : d >= BASELINE_DAYS ? 'success' : d >= 30 ? 'info' : 'warning';
    return <Tag color={color} label={code} className="ptv2-num"/>;
};
